import React, { PropsWithChildren } from "react";
import { Tile } from "../../../tile";

export const PlanTile: React.FC<PropsWithChildren> = ({ children }) => (
  <Tile className="h-88 w-88 flex flex-col gap-4 bg-colorForegroundLightTheme">
    {children}
  </Tile>
);
